import useReveal from "@/hooks/useReveal";

const steps = [
  {
    roman: "I",
    title: "Diagnose the gap",
    body: "We identify the distance between the audience you have and the revenue you don't. We map every leak — offer, funnel, retention.",
  },
  {
    roman: "II",
    title: "Build the machine",
    body: "I design and build it in the background. Offer, sales page, sequences, ads, dashboards — assembled and stress-tested before launch.",
  },
  {
    roman: "III",
    title: "You collect. I stay invisible.",
    body: "You sit in your usual chair. Revenue lands. No team to manage, no agency calls, no credit asked. The work, never the spotlight.",
  },
];

export default function HowItWorks() {
  const ref = useReveal();
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      ref={ref}
      className="reveal relative px-6 md:px-12 py-28 md:py-40 bg-[#0A0A0A] border-t border-[#2E2A28]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-8 mb-20">
          <div className="col-span-12 md:col-span-6">
            <div className="overline section-mark mb-6">The Process</div>
            <h2 className="font-serif-display text-4xl md:text-6xl font-light leading-[1] tracking-tight text-[#F2E7DF]">
              How <span className="italic">it works</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 self-end">
            <p className="text-[#A19D9B] text-lg leading-relaxed">
              Three movements. Quiet, deliberate, repeatable. No retainer theatre,
              no Slack channels with 14 strangers. Just outcomes.
            </p>
          </div>
        </div>

        <ol className="space-y-px">
          {steps.map((s, i) => (
            <li
              key={s.roman}
              data-testid={`step-${i + 1}`}
              className="group grid grid-cols-12 gap-6 py-12 md:py-16 border-t border-[#2E2A28] last:border-b transition-all duration-500"
            >
              <div className="col-span-12 md:col-span-3 font-serif-display text-7xl md:text-9xl font-light text-[#E5C16C] leading-none italic group-hover:text-white transition-colors duration-700">
                {s.roman}
              </div>
              <div className="col-span-12 md:col-span-8 md:col-start-5 self-center">
                <h3 className="font-serif-display text-3xl md:text-4xl font-light text-[#F2E7DF] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-4 text-[#A19D9B] text-base md:text-lg max-w-2xl leading-relaxed">
                  {s.body}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
